/**
 * Route for `pre-landing`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PreLandingPage } from "../features/pre-landing/PreLandingPage";

export const preLandingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/pre-landing",
	component: PreLandingPage,
});

export default preLandingRoute;
